import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mesh200-page',
  templateUrl: './mesh200-page.component.html',
  styleUrls: ['./mesh200-page.component.scss']
})
export class Mesh200PageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
